import { IConfig } from "./Render";
export const Span = ({ className, id, style, children }:IConfig) => {

    return ( <span id = { id }
        style = { style }
        className = { className } >{ children }</span>
    );

}